(() => {
  if (customElements.get('made-with-ingredients')) return;

  class MadeWithIngredients extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-made-with-item]'));
      this.details = Array.from(this.querySelectorAll('details'));
      this.onPointerOver = this.onPointerOver.bind(this);
      this.onFocusIn = this.onFocusIn.bind(this);
      this.onToggle = this.onToggle.bind(this);

      this.items.forEach((item, index) => {
        item.tabIndex = 0;
        item.dataset.index = index;
      });

      this.activate(0);
      this.addEventListener('pointerover', this.onPointerOver);
      this.addEventListener('focusin', this.onFocusIn);
      this.details.forEach((details) => details.addEventListener('toggle', this.onToggle));
    }

    disconnectedCallback() {
      this.removeEventListener('pointerover', this.onPointerOver);
      this.removeEventListener('focusin', this.onFocusIn);
      this.details.forEach((details) => details.removeEventListener('toggle', this.onToggle));
    }

    onPointerOver(event) {
      const item = event.target.closest('[data-made-with-item]');
      if (!item || !this.contains(item)) return;
      this.activate(Number(item.dataset.index));
    }

    onFocusIn(event) {
      const item = event.target.closest('[data-made-with-item]');
      if (!item || !this.contains(item)) return;
      this.activate(Number(item.dataset.index));
    }

    onToggle(event) {
      const openedDetails = event.currentTarget;
      if (!openedDetails.open) return;

      this.details.forEach((details) => {
        if (details !== openedDetails) details.open = false;
      });
    }

    activate(index) {
      this.items.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === index);
        item.setAttribute('aria-current', itemIndex === index ? 'true' : 'false');
      });
    }
  }

  customElements.define('made-with-ingredients', MadeWithIngredients);
})();
